const signs = [
  'сотрудники работают только под контролем;',
  'руководители перегружены операционными задачами;',
  'сотрудники боятся принимать решения;',
  'руководители избегают сложных разговоров;',
  'сильные сотрудники не признают руководителя;',
  'команда ждёт указаний по каждому вопросу;',
  'руководитель не может добиться изменений без давления;',
  'сотрудники формально выполняют задачи, но не проявляют инициативу;',
  'новые руководители испытывают трудности в управлении;',
  'компания быстро растёт и управленческая нагрузка увеличивается;',
  'создаются новые управленческие уровни;',
  'формируется кадровый резерв;',
  'необходимо подготовить будущих руководителей.',
];

export default function WhenNeeded() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Когда компании нужен тренинг по лидерству
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-10 max-w-3xl mx-auto leading-relaxed">
          Признаки, что управленческой команде необходимо развитие лидерских компетенций
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-10 max-w-5xl mx-auto">
          {signs.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-3">
              <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700">{s}</span>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обсудить задачу компании
            <i className="ri-chat-3-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}